var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 text-center",staticStyle:{"margin-top":"50px"}},[_c('span',{staticClass:"spinner-grow spinner-grow-md mr-1",attrs:{"role":"status","aria-hidden":"true"}})])
}]

export { render, staticRenderFns }